export enum HeapEventName {
    applePayButtonView = 'ApplePay Button - View',
    createOrderError = 'OnCreateOrderError',
    createOrderSuccess = 'Create Order Success',
    googlePayButtonView = 'GooglePay Button - View',
    optionalQuestionsFormShown = 'Checkout Optional Questions Shown',
    orderFailure = 'OrderFailure',
    paypalButtonClick = 'Paypal Button - Click',
    paypalButtonView = 'Paypal Button - View',
    placeOrderSuccess = 'Place Order Success',
    requiredQuestionsShown = 'Checkout Required Questions Shown',
    routerLocationChange = 'Checkout Router Location Change',
    submit = 'Checkout Submit',
    ticketSelectionPromoCodeError = 'PromoError',
    timerExpired = 'TimerExpired',
}
